module.exports = __webpack_public_path__ + "static/media/purple1.88d43435.png";